import React, { createContext, useContext, useState } from 'react';

const NavContext = createContext();
export const NavProvider = ({children}) =>{
    const [isShowBurgerMenu, setShowBurgerMenu] = useState(false);

    return (
        <NavContext.Provider value={{ isShowBurgerMenu, setShowBurgerMenu }}>
            {children}
        </NavContext.Provider>
    );
}

export const useNavContext = () => useContext(NavContext);
